import { IconButton, InputProps, TextField } from '@material-ui/core'
import ClearIcon from '@material-ui/icons/Clear'

type TextBoxProps = {
  label?: string
  id: string
  placeholder?: string
  outlined?: boolean
  disabled?: boolean
  multiline?: boolean
  rows?: number
  InputProps?: InputProps
  DOMInputProps?: any
  value: string
  onChange?(value: string): void
  onClick?(): void
  onBlur?(): void
  error?: boolean
  helperText?: string
  clearable?: boolean
  handleClear?: () => void
}

export const TextBox = (props: TextBoxProps) => {
  const {
    label,
    id,
    placeholder,
    outlined,
    disabled,
    multiline,
    rows,
    InputProps,
    DOMInputProps,
    value,
    onChange,
    onClick,
    onBlur,
    error,
    helperText,
    clearable,
    handleClear,
  } = props

  return (
    <div className="flex flex-col w-full">
      {label && <label className={`pb-4 text-lg font-semibold ${disabled ? 'text-body-lighter' : ''}`}>{label}</label>}
      <TextField
        variant={outlined ? 'outlined' : 'standard'}
        placeholder={placeholder}
        id={id}
        fullWidth
        disabled={disabled}
        multiline={multiline}
        minRows={rows}
        value={value}
        onChange={(e) => onChange && onChange(e.target.value)}
        onBlur={() => {
          onBlur && onBlur()
        }}
        onClick={() => {
          onClick && onClick()
        }}
        error={!!error}
        helperText={helperText}
        InputProps={
          clearable
            ? {
                ...InputProps,
                endAdornment: value.length > 1 && (
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClear ?? (() => onChange && onChange(''))}
                    style={{
                      height: '28px',
                      width: '26px',
                      marginRight: '-12px',
                    }}
                  >
                    <ClearIcon fontSize={'small'} />
                  </IconButton>
                ),
              }
            : InputProps
        }
        inputProps={DOMInputProps}
      />
    </div>
  )
}
